import { useCallback, useEffect, useState } from "react";
import { useIsMinimumTablet } from "./use-media-query";

export function useLeftAppMenu(isAppView: boolean) {
  const isMobile = !useIsMinimumTablet();
  const [showLeftMenu, setToggleLeftMenu] = useState(false);
  const toggleLeftMenu = useCallback((value?: boolean) => {
    if (value !== undefined) {
      setToggleLeftMenu(value);
    } else {
      setToggleLeftMenu((prev) => !prev);
    }
  }, []);

  useEffect(() => {
    if (!isAppView) {
      setToggleLeftMenu(false);
    } else {
      setToggleLeftMenu(isMobile ? false : true);
    }
  }, [isAppView, isMobile]);

  return {
    showLeftMenu,
    toggleLeftMenu,
    isMobile,
  };
}
